import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../helpers/axiosConfig';

// Public auth endpoints (no x-auth-token header — these are unauthenticated flows).
const jsonConfig = {
  headers: {
    'Content-Type': 'application/json',
  },
};

// Request a password-reset link. Always resolves with the backend's generic
// message regardless of whether the account exists (anti-enumeration).
export const forgotPassword = createAsyncThunk(
  'auth/forgotPassword',
  async ({ email }, { rejectWithValue }) => {
    const body = JSON.stringify({ email });
    try {
      const res = await axiosInstance.post('users/forgot-password', body, jsonConfig);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

// Set a new password from a reset token. On success returns { token, data }
// and logs the user in (handled in authSlice).
export const resetPassword = createAsyncThunk(
  'auth/resetPassword',
  async ({ token, password }, { rejectWithValue }) => {
    const body = JSON.stringify({ token, password });
    try {
      const res = await axiosInstance.post('users/reset-password', body, jsonConfig);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

// Request a legacy-account activation link. Same anti-enumeration behavior as
// forgotPassword.
export const requestInvite = createAsyncThunk(
  'auth/requestInvite',
  async ({ email }, { rejectWithValue }) => {
    const body = JSON.stringify({ email });
    try {
      const res = await axiosInstance.post('users/request-invite', body, jsonConfig);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

// Activate a legacy account by setting a first password from an invite token.
// On success returns { token, data } and logs the user in (handled in authSlice).
export const acceptInvite = createAsyncThunk(
  'auth/acceptInvite',
  async ({ token, password }, { rejectWithValue }) => {
    const body = JSON.stringify({ token, password });
    try {
      const res = await axiosInstance.post('users/accept-invite', body, jsonConfig);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
